export enum ParentEntity {
  District = 'district',
  Club = 'club',
  League = 'league',
  Cup = 'cup',
  Team = 'team',
  RefereeGroup = 'refereeGroup',
  Match = 'match',
  Region = 'regionChange',
  Follows = 'follows',
}
